import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VContent,[_c('snackbar-store'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }